
import $axios from '@/plugins/axiosInstance'

// import axios from 'axios';

// axios.defaults.withCredentials = true;

export default {
 
        listDurums() {
      return $axios.get('Durums');
    },

  

 
  };